import { useSelector } from "react-redux";
import { selectCurrentAccessToken, selectCurrentUserRole } from "../features/auth/authSlice";
import { Navigate, Outlet } from "react-router-dom";
import { getNavigatePage } from "../hooks/useNavigatePage";

export default function DirectRoute() {

    const accessToken = useSelector(selectCurrentAccessToken);
    const userRole = (useSelector(selectCurrentUserRole) ?? '').toLowerCase();

    const redirectPath = getNavigatePage(userRole || "");

    return accessToken ? ( <Navigate to={redirectPath} replace /> ) : ( <Outlet /> );
}